module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1060.9b6c4ef3.png";